export type NonStandardAgeingDetail = {
  startDate: string
  vitycod: string
  vitylib: string
  vitytyp: 'H' | 'N'
  vitylng: number
  vitydec: number
  tycal: string
}

export type NonStandardAgeingDetails = {
  [key: string]: NonStandardAgeingDetail | null
}

export type AircraftDetail = {
  avnumap?: string
  avimmatr?: string
  appl?: string
  nonStandardAgeingDetails?: NonStandardAgeingDetails
  avnbmot?: number | null
  avnbapu?: number | null
  avnbhyd?: number | null
  escale: string
}

export type Techlog = {
  avnumap?: string
  avimmatr?: string
  rmdoc?: string
  rmdate?: number | null[]
  fh?: string
  cycle?: string
  prevCrm?: string
  prevDate?: string
  nextCrm?: string
  nextDate?: string
  lastCrm?: string
  vovolnum?: string
  voaerodep?: string
  voaeroarr?: string
  voabtps?: string
}

export type PaginatedTechlog = {
  content?: Techlog[]
  totalElements?: number | null
  size?: number | null
  number?: number | null
}

export type FuelDetail = {
  keord?: number | null
  fuelType?: string
  keqte?: number | null
  kebon?: string
}

export type FuelDetailInput = {
  avnumap?: string | null
  rmdate?: number[]
  rmdoc?: string | null
  voord?: number | null
  keord?: number
  fuelTypeCode?: string
  fuelType?: string
  keqte?: number
  kebon?: string
}

export type FlightDetail = {
  avnumap?: string | null
  avimmatr?: string | null
  appl?: string | null
  rma4?: string | null
  rmmm?: string | null
  rmjj?: string | null
  rmdoc?: string | null
  voord?: number | null
  rmdate?: [y: number, m: number, d: number]
  voetops?: boolean | null
  vovolnum?: string | null
  votycod?: string | null
  votylib?: string | null
  vortdcod1?: string | null
  vortdtps1?: number | null
  voann1?: boolean | null
  vortdcod2?: string | null
  vortdtps2?: number | null
  voann2?: boolean | null
  voaerodep?: string | null
  voaeroarr?: string | null
  vobbtps?: number | null
  vobbtpsc?: string | null
  vobbhhmm?: string | null
  vobbdep?: string | null
  vobbarr?: string | null
  voabtps?: number | null
  voabtpsc?: string | null
  voabhhmm?: string | null
  voabdep?: string | null
  voabarr?: string | null
  vocyc?: string | null
  votogo?: number | null
  vocpt1?: string | null
  vocpt2?: string | null
  vocpt3?: string | null
  vocpt4?: string | null
  vocpt5?: string | null
  vocpt6?: string | null
  vocpt7?: string | null
  vocpt8?: string | null
  vocpt9?: string | null
  vocpt10?: string | null
  vocpt11?: string | null
  vocpt12?: string | null
  vocpt13?: string | null
  vocpt14?: string | null
  vocpt15?: string | null
  vocpt16?: string | null
  vocpt17?: string | null
  vocpt18?: string | null
  vocpt19?: string | null
  vocpt20?: string | null
  vooilmo1d?: number | null
  vooilmo2d?: number | null
  vooilmo3d?: number | null
  vooilmo4d?: number | null
  vooilmo5d?: number | null
  vooilmo6d?: number | null
  vooilmo1a?: number | null
  vooilmo2a?: number | null
  vooilmo3a?: number | null
  vooilmo4a?: number | null
  vooilmo5a?: number | null
  vooilmo6a?: number | null
  vooilap1d?: number | null
  vooilap2d?: number | null
  vooilap1a?: number | null
  vooilap2a?: number | null
  vooilhy1d?: number | null
  vooilhy2d?: number | null
  vooilhy3d?: number | null
  vooilhy4d?: number | null
  vooilhy5d?: number | null
  vooilhy6d?: number | null
  vooilhy7d?: number | null
  vooilhy8d?: number | null
  vooilhy9d?: number | null
  vooilhy1a?: number | null
  vooilhy2a?: number | null
  vooilhy3a?: number | null
  vooilhy4a?: number | null
  vooilhy5a?: number | null
  vooilhy6a?: number | null
  vooilhy7a?: number | null
  vooilhy8a?: number | null
  vooilhy9a?: number | null
  ketcatd?: number | null
  ketcata?: number | null
  ketcatp?: number | null
}

export type FlightDetailInput = FlightDetail & {
  _rmdate: Date | null | undefined
}

export type TechlogDetail = {
  avnumap?: string | null
  avimmatr?: string | null
  rmdate?: [y: number, m: number, d: number] | []
  rmdoc?: string | null
  fh?: string | null
  cycle?: string | null
  nextCrm?: string | null
  nextDate?: string | null
  prevCrm?: string | null
  prevDate?: string | null
  lastCrm?: string | null
  flightDetail: FlightDetail[]
  rmdocFull?: string | null
  appl?: string
}

// Defaults

export const FLIGHT_DETAIL_DEFAULTS = Object.fromEntries(
  [
    'avnumap',
    'avimmatr',
    'rma4',
    'rmmm',
    'rmjj',
    'rmdoc',
    'voord',
    'rmdate',
    'voetops',
    'vovolnum',
    'votycod',
    'votylib',
    'vortdcod1',
    'vortdtps1',
    'voann1',
    'vortdcod2',
    'vortdtps2',
    'voann2',
    'voaerodep',
    'voaeroarr',
    'vobbtps',
    'vobbtpsc',
    'vobbhhmm',
    'vobbdep',
    'vobbarr',
    'voabtps',
    'voabtpsc',
    'voabhhmm',
    'voabdep',
    'voabarr',
    'vocyc',
    'votogo',
    'vocpt1',
    'vocpt2',
    'vocpt3',
    'vocpt4',
    'vocpt5',
    'vocpt6',
    'vocpt7',
    'vocpt8',
    'vocpt9',
    'vocpt10',
    'vocpt11',
    'vocpt12',
    'vocpt13',
    'vocpt14',
    'vocpt15',
    'vocpt16',
    'vocpt17',
    'vocpt18',
    'vocpt19',
    'vocpt20',
    'vooilmo1d',
    'vooilmo2d',
    'vooilmo3d',
    'vooilmo4d',
    'vooilmo5d',
    'vooilmo6d',
    'vooilmo1a',
    'vooilmo2a',
    'vooilmo3a',
    'vooilmo4a',
    'vooilmo5a',
    'vooilmo6a',
    'vooilap1d',
    'vooilap2d',
    'vooilap1a',
    'vooilap2a',
    'vooilhy1d',
    'vooilhy2d',
    'vooilhy3d',
    'vooilhy4d',
    'vooilhy5d',
    'vooilhy6d',
    'vooilhy7d',
    'vooilhy8d',
    'vooilhy9d',
    'vooilhy1a',
    'vooilhy2a',
    'vooilhy3a',
    'vooilhy4a',
    'vooilhy5a',
    'vooilhy6a',
    'vooilhy7a',
    'vooilhy8a',
    'vooilhy9a',
    'ketcatd',
    'ketcata',
    'ketcatp',
  ].map((key) => [key, null]),
)
